<template>
  <section class="favorits-section">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12"><h1 class="h1 favorits-section__title">Favorites</h1>
          <div class="favorits-section__wrapper">
            <div class="list-group favorits-section__tab" id="list-tab" role="tablist">
              <a v-for="(category, index) in Object.keys(items)"
                 :key="category"
                 class="list-group-item list-group-item-action"
                 :class="{active: index === 0}"
                 :id="`list-home-list-${index}`"
                 data-toggle="list"
                 :href="`#list-home-${index}`"
                 role="tab" aria-controls="home">{{category}}</a>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="tab-content favorits-section__tabContent" id="nav-tabContent">
            <div v-for="(category, index) in Object.keys(items)"
                 :key="category"
                 class="tab-pane fade"
                 :class="[{show: index === 0}, {active: index === 0}]"
                 :id="`list-home-${index}`" role="tabpanel"
                 :aria-labelledby="`list-home-list-${index}`">
              <div class="container">
                <div class="row">
                  <div class="col-12">
                    <div class="favorits-catalog">
                      <favorite-list-item
                              v-for="item in items[category]"
                              :key="item.id"
                              :item="item"
                      ></favorite-list-item>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: ['items'],
  name: 'FavoriteList',
  mounted () {
    console.log(this.items)
  },
}
</script>

<style scoped>

</style>
